export default __webpack_public_path__ + "static/media/hero-bg-shape-1.68866119.svg";